import "./style.css";

export default class Nav {
  static selector = ".s-side-nav-default";

  constructor(block) {
    this.block = block;
    this.$close = block.querySelector("#close");
    this.$bg = block.querySelector("#nav-bg");
    this.addListeners();
  }

  closeMenu() {
    window.__$ham && window.__$ham.click();
  }

  addListeners() {
    const $a = this.block.querySelectorAll("a");

    $a.forEach(($link) => {
      $link.addEventListener("click", this.closeMenu.bind(this));
    });

    this.$bg.addEventListener("click", this.closeMenu.bind(this));
    this.$close.addEventListener("click", this.closeMenu.bind(this));
  }

  onReady() {}

  onScroll({ y }) {}
}
